module.exports = __webpack_public_path__ + "img/天府五小.9f20c590.jpg";